import { defineStore } from 'pinia'

export interface BuildState {
  storedBuild: string | null
  latestBuild: string | null
  isChecking: boolean
  hasShownUpdateToast: boolean
}

export const useBuildStore = defineStore('build', {
  state: (): BuildState => ({
    storedBuild: null,
    latestBuild: null,
    isChecking: false,
    hasShownUpdateToast: false
  }),
  persist: {
    key: 'build',
    pick: ['storedBuild']
  },
  getters: {
    hasNewBuild(state): boolean {
      if (!state.storedBuild || !state.latestBuild) {
        return true
      }
      return state.latestBuild !== state.storedBuild
    },

    shouldShowToast(): boolean {
      return this.hasNewBuild && !this.hasShownUpdateToast
    }
  },
  actions: {
    async fetchLatestBuild(): Promise<string> {
      const response = await fetch('/build.txt?=' + Date.now())
      if (!response.ok) {
        return 'initial'
      }
      const build = (await response.text()).trim()
      this.latestBuild = build
      return build
    },

    updateStoredBuild(build: string) {
      this.storedBuild = build
    },

    async checkForNewBuild(): Promise<boolean> {
      this.latestBuild = await this.fetchLatestBuild()

      if (!this.storedBuild) {
        return true
      }

      return this.hasNewBuild
    },

    markToastAsShown() {
      this.hasShownUpdateToast = true
    },

    resetToastState() {
      this.hasShownUpdateToast = false
    },

    setCheckingState(isChecking: boolean) {
      this.isChecking = isChecking
    }
  }
})
